<small class="debug">{{me}}</small>
<div class="playlist_properties">
  <div class="edit-panel-wrapper" [ngClass]="{showPieChart: showPie === true, hidePieChart: showPie === false}">
    <!--        [scheme]="colorScheme"-->
    <ngx-charts-pie-chart
      [results]="dataStoragePercent"
      [gradient]="false"
      [view]="[160,160]"
      [legend]="false"
      [labels]="false"
      [tooltipDisabled]="false">
    </ngx-charts-pie-chart>
    <mat-label>
      {{'general.totalHourUsed' | transloco}}: {{totalPercentage}}%
    </mat-label>
  </div>
  @if (dynamicsInitialized) {
    <div>
      <dynamic-form
        [fields]="uiConfigInit"
        [ignoreValidation]="true"
        (submit)="submit($event)">
      </dynamic-form>
      <br/>
      <button style="position: relative; left: -5px;" mat-button matTooltip="{{'general.getToHundred' | transloco}}" (click)="normalizeValues()">
        <mat-icon>repeat_one_on</mat-icon>
        {{'general.normalize' | transloco}}
      </button>
      <span style="position: relative; left: 30px; top: 2px">[ {{totalPercentage}}% ]</span>
    </div>
  }
  <br/>
  <br/>
  <!--    <div fxLayout="row" fxLayoutAlign="start start">-->
  <!--        <mat-label class="smallLabelSeq">rep/h: number times to repeat in one hour</mat-label>-->
  <!--        <mat-label class="smallLabelSeq">%/h: percent content will take of the hour</mat-label>-->
<!--    </div>-->
<br/>
</div>
